import React, { useEffect, useState } from "react";
import ChartCard from "../ChartCard";
import dynamic from "next/dynamic";
import {
  getLineChartOptions,
  getLineChartSeries,
  initAcquisitionData,
  initRenewalData,
  xAxisInitData,
  yAxisInitData,
} from "./data";
import ChartHeading from "../ChartHeading";
import { useCalculatorController } from "../../../context/context";
import { useMetricTable } from "../../../AllMetrics/MetricsTable/useMetricTable";

const ApexCharts = dynamic(() => import("react-apexcharts"), { ssr: false });
const DEFAULT_RENEWAL_FIELD = 1;

const RevenueLineChart = () => {
  const { controller } = useCalculatorController();
  const { isCalcFormSubmitted, renewalFieldsCount } = controller;
  const { tableData } = useMetricTable();

  const [chartData, setChartData] = useState({
    renewalData: initRenewalData,
    acquisitionData: initAcquisitionData,
    xAxisData: xAxisInitData,
    yAxisData: yAxisInitData,
  });

  useEffect(() => {
    if (isCalcFormSubmitted) {
      const totalFieldsCount = renewalFieldsCount + DEFAULT_RENEWAL_FIELD;

      setChartData({
        ...chartData,
        renewalData: tableData.revenueRowData.slice(0, totalFieldsCount),
        acquisitionData: Array(totalFieldsCount).fill(
          tableData.acquisitionCost
        ),
        xAxisData: {
          min: 1,
          max: totalFieldsCount,
          categoriesLength: totalFieldsCount,
          tickAmount: renewalFieldsCount,
          rotateLabels: renewalFieldsCount > 6,
        },
        yAxisData: {
          min: 0,
          max:
            tableData.revenueRowData?.at(renewalFieldsCount) >
            tableData.acquisitionCost
              ? tableData.revenueRowData?.at(renewalFieldsCount)
              : tableData.acquisitionCost * 1.2,
        },
      });
    }
  }, [tableData, isCalcFormSubmitted]);

  return (
    <ChartCard>
      <ChartHeading title="Cumulative Revenue" />
      <ApexCharts
        options={getLineChartOptions(chartData.xAxisData, chartData.yAxisData)}
        type="line"
        series={getLineChartSeries(
          chartData.renewalData,
          chartData.acquisitionData
        )}
        height={350}
      />
    </ChartCard>
  );
};

export default RevenueLineChart;
